import { useState } from "react";
import { SelectableAnnualWheelActivityTableProps } from "./SelectableAnnualWheelActivityTable.tsx";
import { sortTableData } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useRecurringIntervalFormatting } from "../../../annualWheel/AnnualWheel.hooks.ts";

export function useSelectableAnnualWheelActivityTable(props: SelectableAnnualWheelActivityTableProps) {
    const [orderBy, setOrderBy] = useState<string>("name");
    const [order, setOrder] = useState<"asc" | "desc">("asc");
    const formatRecurringInterval = useRecurringIntervalFormatting();

    function onSortClick(columnName: string) {
        setOrderBy(columnName);
        setOrder(order === "asc" ? "desc" : "asc");
    }

    let selectedAnnualWheelActivities = props.selectableAnnualWheelActivities
        .filter((x) => props.selectedAnnualWheelActivities.includes(x.id))
        .map((x) => {
            return {
                ...x,
                recurringIntervalInMonths: x.recurringInterval ?? 999,
                recurringIntervalString: formatRecurringInterval(x.recurringInterval, x.recurringIntervalType),
            };
        });
    selectedAnnualWheelActivities = sortTableData(selectedAnnualWheelActivities, orderBy, order);

    return { selectedAnnualWheelActivities, order, orderBy, onSortClick };
}
